import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { QRCodeCanvas } from "qrcode.react";
import { Helmet } from "react-helmet";
import "./LoginPage.css";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5050/api";

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [twoFactorRequired, setTwoFactorRequired] = useState(false);
  const [setup2FA, setSetup2FA] = useState(false);
  const [otpauthUrl, setOtpauthUrl] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const completeLogin = (data) => {
  localStorage.setItem("token", data.token);
  localStorage.setItem("firstName", data.firstName);
  navigate("/home");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const payload = { email, password };
      if (twoFactorRequired) payload.otp = otp;

      const res = await axios.post(`${API_URL}/login`, payload);

      // First-time 2FA setup
      if (res.data.setupRequired) {
        setSetup2FA(true);
        setOtpauthUrl(res.data.otpauth);
        return;
      }

      // Returning user requires 2FA
      if (res.data.twoFactorRequired) {
        setTwoFactorRequired(true);
        return;
      }

      // Successful login
      if (res.data.success) {
        completeLogin(res.data);
        console.log("Token:", res.data.token)
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || "Login failed. Check credentials or OTP.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(`${API_URL}/login`, {
        email,
        password,
        otp,
      });

      if (res.data.success) {
        completeLogin(res.data);
      } else {
        setError("OTP verification failed. Check your code.");
      }
    } catch (err) {
      console.error(err);
      setError("OTP verification failed. Check your code.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="login-wrapper">
      <Helmet>
        <title>RCM | Login</title>
      </Helmet>
      <div className="login-content">
      <div className="login-box">
        <a href="/" className="logo">
        <img src="/RCM-Logo.png" alt="RCM Logo" className="login-logo" />
        </a>
        {/* Standard login form */}
        {!twoFactorRequired && !setup2FA && (
          <form onSubmit={handleLogin}>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? "Loading..." : "Login"}
            </button>
          </form>
        )}

        {/* First-time 2FA setup */}
        {setup2FA && (
          <div className="setup-2fa">
            <h3>Scan this QR code with your 2FA app:</h3>
            {otpauthUrl ? (
              <QRCodeCanvas value={otpauthUrl} size={200} />
            ) : (
              <p>Loading QR code...</p>
            )}
            <p>
              Or manually enter this key:{" "}
              <strong>
                {otpauthUrl.split("secret=")[1]?.split("&")[0] || ""}
              </strong>
            </p>
            <form onSubmit={handleVerifyOTP}>
              <label htmlFor="otp">Enter OTP from app</label>
              <input
                id="otp"
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? "Verifying..." : "Verify OTP"}
              </button>
            </form>
          </div>
        )}

        {/* Returning user OTP verification */}
        {twoFactorRequired && !setup2FA && (
          <form onSubmit={handleVerifyOTP}>
            <label htmlFor="otp">Enter OTP</label>
            <input
              id="otp"
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? "Verifying..." : "Verify OTP"}
            </button>
          </form>
        )}

        {error && <p className="login-error">{error}</p>}
      </div>
      </div>

      <footer>
        <p>&copy; 2026 Rebus Capital Management LLC | All rights reserved.</p>
      </footer>
    </div>
  );
}
